/* Popelote — JS natif, sans dépendance (version Shopify). */
(function () {
  'use strict';
  document.documentElement.classList.add('js');

  function money(cents) {
    var v = cents / 100;
    var lang = document.documentElement.lang || 'en';
    var digits = v % 1 === 0 ? 0 : 2;
    return new Intl.NumberFormat(lang, { style: 'currency', currency: 'EUR', minimumFractionDigits: digits, maximumFractionDigits: digits }).format(v);
  }

  /* Estimation du total d'une ligne selon les paliers de lot (reflète les remises automatiques Shopify :
     montant fixe dès 2 articles, puis dès 3 articles). data-lots = "prix2,prix3" en centimes. */
  function lotTotal(n, unit, lots) {
    var total = n * unit;
    if (!lots || lots.length < 2) return total;
    if (n >= 3 && lots[1] > 0) return total - Math.max(0, 3 * unit - lots[1]);
    if (n === 2 && lots[0] > 0) return total - Math.max(0, 2 * unit - lots[0]);
    return total;
  }

  /* Menu mobile (plein écran sous l'en-tête, défilement de la page bloqué) */
  var toggle = document.querySelector('.nav-toggle');
  var nav = document.getElementById('main-nav');
  if (toggle && nav) {
    var header = toggle.closest('.site-header');
    var setNav = function (open) {
      if (open && header) nav.style.setProperty('--nav-top', Math.round(header.getBoundingClientRect().bottom) + 'px');
      toggle.setAttribute('aria-expanded', String(open));
      nav.classList.toggle('is-open', open);
      document.documentElement.classList.toggle('nav-open', open);
    };
    toggle.addEventListener('click', function () { setNav(toggle.getAttribute('aria-expanded') !== 'true'); });
    nav.querySelectorAll('a').forEach(function (a) { a.addEventListener('click', function () { setNav(false); }); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && nav.classList.contains('is-open')) { setNav(false); toggle.focus(); }
    });
  }

  /* Typographie française : espace fine insécable avant ? ! : ; » et après « (évite les « ? » seuls à la ligne) */
  if ((document.documentElement.lang || '').indexOf('fr') === 0) {
    var tw = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, {
      acceptNode: function (n) {
        return /^(SCRIPT|STYLE|TEXTAREA|CODE|PRE)$/.test(n.parentNode.nodeName) ? NodeFilter.FILTER_REJECT : NodeFilter.FILTER_ACCEPT;
      }
    });
    var tn;
    while ((tn = tw.nextNode())) {
      if (/ [?!:;»]|« /.test(tn.nodeValue)) tn.nodeValue = tn.nodeValue.replace(/ ([?!:;»])/g, '\u202F$1').replace(/« /g, '«\u202F');
    }
  }

  /* Dates de livraison estimées : aujourd'hui + N jours (data-ship-days), au format de la langue (« 15 octobre »). */
  var shipFmt = null;
  try { shipFmt = new Intl.DateTimeFormat(document.documentElement.lang || 'en', { day: 'numeric', month: 'long' }); } catch (e) {}
  document.querySelectorAll('[data-ship-date]').forEach(function (el) {
    var days = parseInt(el.getAttribute('data-ship-days') || '15', 10);
    var d = new Date(); d.setDate(d.getDate() + days);
    el.textContent = shipFmt ? shipFmt.format(d) : String(d.getDate()).padStart(2, '0') + '/' + String(d.getMonth() + 1).padStart(2, '0');
  });

  /* Galerie produit */
  document.querySelectorAll('[data-gallery]').forEach(function (g) {
    var main = g.querySelector('[data-gallery-main] img');
    var cap = g.querySelector('[data-gallery-main] figcaption');
    if (!main) return;
    g.querySelectorAll('.gallery__thumb').forEach(function (btn) {
      btn.addEventListener('click', function () {
        g.querySelectorAll('.gallery__thumb').forEach(function (b) { b.setAttribute('aria-current', 'false'); });
        btn.setAttribute('aria-current', 'true');
        var srcset = btn.getAttribute('data-srcset');
        if (srcset) { main.setAttribute('srcset', srcset); } else { main.removeAttribute('srcset'); }
        main.src = btn.getAttribute('data-src');
        main.alt = btn.getAttribute('data-alt') || '';
        if (cap) cap.textContent = btn.getAttribute('data-caption') || '';
      });
    });
  });

  /* Sélecteurs de quantité */
  function bindQty(root, onChange) {
    if (!root) return;
    var input = root.querySelector('input');
    var min = parseInt(input.min || '1', 10), max = parseInt(input.max || '10', 10);
    function set(v) {
      v = Math.max(min, Math.min(max, isNaN(v) ? min : v));
      input.value = v;
      if (onChange) onChange(v);
    }
    root.querySelector('[data-qty-minus]').addEventListener('click', function () { set(parseInt(input.value, 10) - 1); });
    root.querySelector('[data-qty-plus]').addEventListener('click', function () { set(parseInt(input.value, 10) + 1); });
    input.addEventListener('change', function () { set(parseInt(input.value, 10)); });
  }

  /* Fiche produit : quantité, variante et total estimé (l'ajout au panier est un vrai formulaire Shopify) */
  document.querySelectorAll('[data-buy]').forEach(function (buy) {
    var total = buy.querySelector('[data-buy-total]');
    var qtyInput = buy.querySelector('input[name="quantity"]');
    var lots = (buy.getAttribute('data-lots') || '').split(',').filter(Boolean).map(function (x) { return parseInt(x, 10) || 0; });
    function unit() { return parseInt(buy.getAttribute('data-unit-price') || '0', 10); }
    function refresh() {
      if (!total || !qtyInput) return;
      total.textContent = money(lotTotal(parseInt(qtyInput.value, 10) || 1, unit(), lots));
    }
    bindQty(buy.querySelector('[data-qty]'), refresh);
    var select = buy.querySelector('[data-variant-select]');
    if (select) {
      select.addEventListener('change', function () {
        var opt = select.options[select.selectedIndex];
        buy.setAttribute('data-unit-price', opt.getAttribute('data-price'));
        document.querySelectorAll('[data-product-price]').forEach(function (p) { p.textContent = opt.getAttribute('data-price-text'); });
        var url = new URL(window.location.href);
        url.searchParams.set('variant', opt.value);
        window.history.replaceState({}, '', url.toString());
        refresh();
      });
    }
    refresh();
  });

  /* Filtre collection (par tags produits) */
  var filterBar = document.querySelector('[data-filters]');
  if (filterBar) {
    var cards = document.querySelectorAll('[data-cat]');
    var empty = document.querySelector('[data-empty]');
    filterBar.querySelectorAll('.filter-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var f = btn.getAttribute('data-filter');
        filterBar.querySelectorAll('.filter-btn').forEach(function (b) { b.setAttribute('aria-pressed', String(b === btn)); });
        var shown = 0;
        cards.forEach(function (c) {
          var ok = f === 'tous' || c.getAttribute('data-cat').split(' ').indexOf(f) > -1;
          c.hidden = !ok; if (ok) shown++;
        });
        if (empty) empty.hidden = shown > 0;
        var live = document.querySelector('[data-filter-status]');
        if (live) live.textContent = (live.getAttribute(shown > 1 ? 'data-other' : 'data-one') || '__N__').replace('__N__', shown);
      });
    });
  }

  /* Panier : mise à jour automatique des quantités (formulaire Shopify /cart) */
  document.querySelectorAll('[data-cart-form]').forEach(function (form) {
    var timer;
    form.querySelectorAll('[data-qty]').forEach(function (q) {
      bindQty(q, function () {
        clearTimeout(timer);
        timer = setTimeout(function () {
          var upd = document.createElement('input');
          upd.type = 'hidden'; upd.name = 'update'; upd.value = '1';
          form.appendChild(upd);
          form.submit();
        }, 500);
      });
    });
  });

  /* Rangées défilantes */
  document.querySelectorAll('[data-rail]').forEach(function (rail) {
    var wrap = rail.closest('section');
    function step() { var c = rail.querySelector('li'); return c ? c.getBoundingClientRect().width + 20 : 300; }
    var prev = wrap.querySelector('[data-rail-prev]'), next = wrap.querySelector('[data-rail-next]');
    if (prev) prev.addEventListener('click', function () { rail.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { rail.scrollBy({ left: step(), behavior: 'smooth' }); });
  });

  /* Apparition douce des blocs au défilement (patch v8). Rien n'est masqué sans JS
     ni pour les visiteurs qui demandent à réduire les animations. */
  if ('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    var revealSel = 'main h2, main .lead, .tile, .learn-step, .learn__media, .compare__col, .offer__tiles > *, ' +
      '.reassure-grid > *, .product-card, .rail-card, .review-card, .fictif-banner, .accordion > *, .noel__media';
    var revealObs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var el = e.target;
        revealObs.unobserve(el);
        el.classList.add('is-in');
        var d = parseInt(el.style.getPropertyValue('--d'), 10) || 0;
        setTimeout(function () { el.classList.remove('reveal', 'is-in'); el.style.removeProperty('--d'); }, 800 + d);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
    document.querySelectorAll(revealSel).forEach(function (el) {
      if (el.closest('.hero-band') || el.closest('.site-header')) return;
      var i = Array.prototype.indexOf.call(el.parentNode.children, el);
      el.style.setProperty('--d', Math.min(i, 5) * 80 + 'ms');
      el.classList.add('reveal');
      revealObs.observe(el);
    });
  }

  /* Sélecteur de langue (patch v9) : fermer au clic extérieur et avec Échap */
  document.querySelectorAll('[data-lang-menu]').forEach(function (menu) {
    document.addEventListener('click', function (e) { if (menu.open && !menu.contains(e.target)) menu.open = false; });
    menu.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && menu.open) { menu.open = false; menu.querySelector('summary').focus(); }
    });
  });
})();
